import { PDFReaderBrowser } from '@/components/file-viewers/reactPdf';
import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { useIsMobile } from '@/hooks/use-IsMobile';

export const PreviewPdfModal = ({
  isOpen = false,
  onClose = () => {},
  file,
  minW = '850px',
  maxW = '850px',
}) => {
	const isMobile = useIsMobile();
  return (
    <Modal isOpen={isOpen} onClose={onClose}  size={isMobile ? 'full' : 'md'}>
      <ModalOverlay />
      <ModalContent  h={isMobile ? '100dvh' : '90vh'}
        minW={isMobile ? '100vw' : minW}
        maxW={isMobile ? '100vw' : maxW}
        borderRadius={isMobile ? 0 : '12px'} position="fixed" overflow="hidden">
        <ModalCloseButton
          size="lg"
          position="absolute"
          top="4px"
          right="4px"
          zIndex={100}
          bg="transparent"
          _hover={{
            bg: '#F6F7F7',
          }}
        />
        <ModalHeader px={isMobile ? 4 : 6}
          py={isMobile ? 3 : 4}>
          <Text  fontSize={isMobile ? 'sm' : 'md'}
            noOfLines={1}>{file?.file_name}</Text>
        </ModalHeader>
        <ModalBody p={isMobile ? 0 : 4}
          h="calc(100% - 56px)">
          <Flex w="100%" h="100%" overflow="auto" flexDir="column">
            <PDFReaderBrowser
              file={
                file instanceof File ? URL.createObjectURL(file) : file?.url
              }
              content_type={file?.content_type || file?.type}
              preview_url={file?.preview?.url}
            />
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
